/// <reference lib="dom"/>

export interface WavSource {
  sampleRate: number;
  numberOfChannels: number;
  length: number;
  getChannelData(channel: number): Float32Array;
}

function WriteAscii(view: DataView, offset: number, text: string) {
  for (let i = 0; i < text.length; i++) view.setUint8(offset + i, text.charCodeAt(i));
}

export function EncodeWavBytes(source: WavSource): ArrayBuffer {
  const channels = source.numberOfChannels;
  const bytesPerSample = 2;
  const blockAlign = channels * bytesPerSample;
  const dataLength = source.length * blockAlign;
  const buffer = new ArrayBuffer(44 + dataLength);
  const view = new DataView(buffer);

  WriteAscii(view, 0, "RIFF");
  view.setUint32(4, 36 + dataLength, true);
  WriteAscii(view, 8, "WAVE");
  WriteAscii(view, 12, "fmt ");
  view.setUint32(16, 16, true);
  view.setUint16(20, 1, true);
  view.setUint16(22, channels, true);
  view.setUint32(24, source.sampleRate, true);
  view.setUint32(28, source.sampleRate * blockAlign, true);
  view.setUint16(32, blockAlign, true);
  view.setUint16(34, bytesPerSample * 8, true);
  WriteAscii(view, 36, "data");
  view.setUint32(40, dataLength, true);

  const data = Array.from({ length: channels }, (_, c) => source.getChannelData(c));
  let offset = 44;
  for (let i = 0; i < source.length; i++) {
    for (let c = 0; c < channels; c++) {
      const v = Math.max(-1, Math.min(1, data[c][i]));
      view.setInt16(offset, v < 0 ? v * 0x8000 : v * 0x7fff, true);
      offset += bytesPerSample;
    }
  }
  return buffer;
}

export function EncodeWav(source: WavSource): Blob {
  return new Blob([EncodeWavBytes(source)], { type: "audio/wav" });
}
